import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/fugus-logo.webp";
import LogoutConfirmation from "../pages/shared/logoutConfirmation/LogoutConfirmation";
import Copyright from "../pages/shared/copyright/Copyright";
import api from "../shared/utils/request";
import SubDrawer from "../pages/shared/drawerComponents/subDrawer";

const MobileDrawer = ({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  activeDrawerOverlay,
  setActiveDrawerOverlay,
  isProfileDropdownOpen,
  setIsProfileDropdownOpen,
}) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [subCategoriesLoading, setSubCategoriesLoading] = useState(false);
  const [subCategoriesError, setSubCategoriesError] = useState(null);
  const isToken = localStorage.getItem("token");

  useEffect(() => {
    fetchSubCategories();
  }, []);

  const fetchSubCategories = async () => {
    setSubCategoriesLoading(true);
    setSubCategoriesError(null);
    try {
      const data = await api.get("customer/sub-categories");
      if (Array.isArray(data?.data)) {
        setSubCategories(data.data);
      } else if (Array.isArray(data)) {
        setSubCategories(data);
      }
    } catch (error) {
      console.error("Failed to fetch sub-categories:", error);
      setSubCategoriesError("Failed to load categories");
    } finally {
      setSubCategoriesLoading(false);
    }
  };

  const closeDrawer = () => {
    setIsMobileMenuOpen(false);
    setActiveDrawerOverlay("");
    setIsProfileDropdownOpen(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    setShowLogoutModal(false);
    setIsMobileMenuOpen(false);
    window.location.href = "/";
  };
  const staticProfileOptions = [
    { id: 1, label: "My Account", to: "/my-account", icon: "ph ph-user" },
    { id: 2, label: "My Orders", to: "/my-orders", icon: "ph ph-package" },
    {
      id: 4,
      label: "Address Book",
      to: "/address-book",
      icon: "ph ph-map-pin",
    },
    { id: 5, label: "Logout", to: "#", icon: "ph ph-sign-out" },
  ];
  return (
    <div
      className={`mobile-menu-drawer ${isMobileMenuOpen ? "is-open" : ""}`}
      aria-hidden={!isMobileMenuOpen}
    >
      <button
        type="button"
        className="mobile-menu-drawer__backdrop"
        aria-label="Close menu"
        onClick={() => {
          setIsMobileMenuOpen(false);
          setActiveDrawerOverlay("");
          setIsProfileDropdownOpen(false);
        }}
      />
      <aside className="mobile-menu-drawer__panel" aria-label="Mobile menu">
        <div className="mobile-menu-drawer__head">
          <Link to="/" className="mobile-menu-drawer__logo-link">
            <img src={Logo} alt="Fugu's" className="mobile-menu-drawer__logo" />
          </Link>
          <button
            type="button"
            className="mobile-menu-drawer__close"
            aria-label="Close menu"
            onClick={() => {
              setIsMobileMenuOpen(false);
              setActiveDrawerOverlay("");
              setIsProfileDropdownOpen(false);
            }}
          >
            <i className="ph ph-x" />
          </button>
        </div>
        <nav className="mobile-menu-drawer__nav" aria-label="Site links">
          <Link to="/" className="mobile-menu-drawer__link">
            <i className="ph ph-house" />
            <span>Home</span>
          </Link>
          <button
            type="button"
            className="mobile-menu-drawer__link mobile-menu-drawer__link-btn"
            onClick={() => setActiveDrawerOverlay("Categories")}
          >
            <i className="ph ph-squares-four" />
            <span>Categories</span>
            <i className="ph ph-caret-right mobile-menu-drawer__link-arrow" />
          </button>
          <Link to="/cart" className="mobile-menu-drawer__link">
            <i className="ph ph-handbag" />
            <span>Cart</span>
          </Link>
          <Link to="/wishlist" className="mobile-menu-drawer__link">
            <i className="ph ph-storefront" />
            <span>Wishlist</span>
          </Link>
          {isToken ? (
            <>
              <button
                type="button"
                className="mobile-menu-drawer__link mobile-menu-drawer__link-btn"
                onClick={() => setActiveDrawerOverlay("My Account")}
              >
                <i className="ph ph-user-circle" />
                <span>Profile</span>
                <i className="ph ph-caret-right mobile-menu-drawer__link-arrow" />
              </button>
              {/* <button
                type="button"
                className="mobile-menu-drawer__link mobile-menu-drawer__link-btn"
                onClick={() => setIsProfileDropdownOpen((prev) => !prev)}
                aria-expanded={isProfileDropdownOpen}
              >
                <i className="ph ph-user-circle" />
                <span>Profile</span>
                <i
                  className={`ph ph-caret-down mobile-menu-drawer__link-arrow ${
                    isProfileDropdownOpen ? "is-open" : ""
                  }`}
                />
              </button> */}
              {/* <div
                className={`mobile-menu-drawer__profile-dropdown ${
                  isProfileDropdownOpen ? "is-open" : ""
                }`}
              >
                {staticProfileOptions.map((item) =>
                  item?.label === "Logout" ? (
                    <span
                      key={item.id}
                      className="mobile-menu-drawer__profile-link"
                      onClick={() => {
                        setShowLogoutModal(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <i className={item.icon} aria-hidden="true" />
                      <span>{item.label}</span>
                    </span>
                  ) : (
                    <NavLink
                      key={item.id}
                      to={item.to}
                      className={({ isActive }) =>
                        `mobile-menu-drawer__profile-link${
                          isActive ? " is-active" : ""
                        }`
                      }
                    >
                      <i className={item.icon} aria-hidden="true" />
                      <span>{item.label}</span>
                    </NavLink>
                  ),
                )}
              </div> */}
            </>
          ) : (
            <button
              type="button"
              className="mobile-menu-drawer__link mobile-menu-drawer__link-btn"
              onClick={() => {
                setIsMobileMenuOpen(false);
                window.showLoginModal?.();
                return;
              }}
            >
              <i className="ph ph-sign-in" />
              <span>Login</span>
            </button>
          )}
        </nav>
        <SubDrawer
          activeDrawerOverlay={activeDrawerOverlay}
          setActiveDrawerOverlay={setActiveDrawerOverlay}
          subCategoriesLoading={subCategoriesLoading}
          subCategoriesError={subCategoriesError}
          fetchSubCategories={fetchSubCategories}
          subCategories={subCategories}
          closeDrawer={closeDrawer}
          staticProfileOptions={staticProfileOptions}
          setShowLogoutModal={setShowLogoutModal}
        />
        <div className="mobile-menu-drawer__footer-links">
          <Link
            to="/privacy-policy"
            onClick={closeDrawer}
          >
            <i className="ph ph-shield-check" />
            <span>Privacy Policy</span>
          </Link>
          <Link
            to="/terms-and-conditions"
            onClick={closeDrawer}
          >
            <i className="ph ph-file-text" />
            <span>Terms & Conditions</span>
          </Link>
          <a href="#" onClick={(e) => e.preventDefault()}>
            <i className="ph ph-question" />
            <span>FAQ</span>
          </a>
          <a href="#" onClick={(e) => e.preventDefault()}>
            <i className="ph ph-headset" />
            <span>Contact Us</span>
          </a>
          <a href="#" onClick={(e) => e.preventDefault()}>
            <i className="ph ph-info" />
            <span>About Us</span>
          </a>
          <a href="#" onClick={(e) => e.preventDefault()}>
            <i className="ph ph-storefront" />
            <span>Our Stores</span>
          </a>
        </div>
        <Copyright className="mobile-menu-drawer__copyright" />
      </aside>
      <LogoutConfirmation
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={handleLogout}
      />
    </div>
  );
};
export default MobileDrawer;
